import { requestDeviceEvents } from '@/utils/io/motion'
import { showSettings } from '@/utils/io/deviceSettings'
import { requestLocalNotificationsPermission } from '@/utils/notifications'
import { Platform } from 'quasar'

export const ALARM_SOUND = 'audio/alarm.mp3'

export const PTI_STATUS_INACTIVE = {
  value: 'off',
  label: 'Inactif'
}

export const PTI_PERMISSION_TYPE_REQUIRED = 'required'
export const PTI_PERMISSION_TYPE_OPTIONAL = 'optional'

export const SETTINGS_APP_DETAILS = 'application_details'
export const SETTINGS_NOTIFICATIONS = 'notification_id'

export const PTI_PERMISSION_RESOLUTION_SETTINGS_APP_DETAILS = {
  key: SETTINGS_APP_DETAILS,
  fix: () => showSettings(SETTINGS_APP_DETAILS),
  label: `Ouvrir les paramètres de l'application`
}
export const PTI_PERMISSION_RESOLUTION_ENABLE_MOTION = {
  key: 'enable_motion',
  fix: () => requestDeviceEvents(),
  isAvailable: true,
  label: `Autoriser l'accès au gyroscope et à l'accéléromètre`
}
export const PTI_PERMISSION_RESOLUTION_ENABLE_NOTIFICATIONS = {
  key: 'enable_notification',
  fix: () => requestLocalNotificationsPermission(),
  isAvailable: true,
  label: `Autoriser les notifications`
}
export const PTI_PERMISSION_RESOLUTION_SETTINGS_NOTIFICATIONS = {
  key: SETTINGS_NOTIFICATIONS,
  fix: () => showSettings(SETTINGS_NOTIFICATIONS),
  isAvailable: Platform.is.cordova,
  label: `Ouvrir les paramètres de notification`
}
export const PTI_PERMISSION_RESOLUTION_DOWNLOAD_APP = {
  key: 'download_app',
  fix: () => {
    window.location.href = process.env.APP.store[Platform.is.ios ? 'ios' : 'android']
  },
  isAvailable: !Platform.is.cordova,
  label: `Télécharger l'application`,
  icon: Platform.is.ios
    ? 'fab fa-app-store'
    : 'fab fa-google-play'
}

export const PTI_REQUIRED_PERMISSION_MOTION = {
  key: 'DEVICE_MOTION',
  type: Platform.is.cordova
    ? PTI_PERMISSION_TYPE_REQUIRED
    : PTI_PERMISSION_TYPE_OPTIONAL,
  check: () => requestDeviceEvents(true),
  isAvailable: true,
  label: 'Gyroscope et Accéléromètre',
  reason: `Nous avons besoin de l'accéléromètre et du gyroscope pour faire fonctionner le PTI.`,
  resolution: `Accepter les autorisations`,
  resolutionOptions: [
    PTI_PERMISSION_RESOLUTION_ENABLE_MOTION
  ]
}

export const PTI_REQUIRED_PERMISSION_NOTIFICATIONS = {
  key: 'ACCESS_NOTIFICATIONS',
  type: PTI_PERMISSION_TYPE_REQUIRED,
  check: () => requestLocalNotificationsPermission(),
  isAvailable: true,
  label: 'Notification',
  reason: 'Nous avons besoin des notifications pour vous envoyer des alertes PTI.',
  resolution: `Vérifier que les notifications sont bien activées`,
  resolutionOptions: [
    PTI_PERMISSION_RESOLUTION_ENABLE_NOTIFICATIONS,
    PTI_PERMISSION_RESOLUTION_SETTINGS_NOTIFICATIONS
  ]
}

export const PTI_REQUIRED_PERMISSION_APPLICATION = {
  key: 'USE_MOBILE_APP',
  type: PTI_PERMISSION_TYPE_OPTIONAL,
  check: () => !!Platform.is.cordova,
  isAvailable: !Platform.is.cordova,
  label: `Application mobile ${process.env.APP.name}`,
  reason: `Vous utilisez ${process.env.APP.name} en mode "web". Certaines options du PTI fonctionnent en mode dégradé`,
  resolution: `Télécharger l'application mobile ${process.env.APP.name}`,
  resolutionOptions: [
    PTI_PERMISSION_RESOLUTION_DOWNLOAD_APP
  ]
}

export const PTI_REQUIRED_PERMISSIONS = [
  PTI_REQUIRED_PERMISSION_MOTION,
  PTI_REQUIRED_PERMISSION_NOTIFICATIONS,
  PTI_REQUIRED_PERMISSION_APPLICATION
]
